export default {
  BUSINESS_HOURS: 'business_hours',
  NONE: 'none',
  RECURRING: 'recurring'
};
